import Api from './Api';

const ClientKeyMap = {};
export default {
  ClientKeyMap, // 字典值{t: []}
  /**
   * 返回字典值
   * @param t 类型
   * @param k 键
   * @returns string
   */
  getValue(t, k) {
    if (k === undefined) {
      return '';
    }
    if (this.ClientKeyMap[t] === undefined || this.ClientKeyMap[t][k] === undefined) {
      return `${t}:${k}`;
    }
    return this.ClientKeyMap[t][k];
  },
  /**
   * 返回字典列表
   * @param t 类型
   */
  getValues(t) {
    return this.ClientKeyMap[t];
  },
  getKeyMap() {
    return new Promise((resolve, reject) => {
      Api.post('public/key-map', {})
        .then((json) => {
          json.key_map.forEach((item) => {
            if (this.ClientKeyMap[item.t] === undefined) {
              this.ClientKeyMap[item.t] = {};
            }
            this.ClientKeyMap[item.t][item.k] = item.v;
          });
          resolve(json);
        }).catch((err) => {
          reject(err);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/lib/KeyMap.js